import React from 'react';
import { connect } from 'react-redux';
import * as selectors from 'selectors/pathBuilder';
import LessonContent from 'components/PathViewer/Content/LessonContent';
import MaximumAttemptsReached from 'components/PathViewer/Content/MaximumAttemptsReached';

function showLesson(content) {
  return content.status !== 'awaitingReassignment';
}

function Content({ ...props }) {
  return showLesson(props) ? (
    <LessonContent {...props} />
  ) : (
    <MaximumAttemptsReached {...props} />
  );
}

const mapStateToProps = () => {
  const getStepNumber = selectors.getStepNumber();
  return (state, props) => ({
    stepNumber: getStepNumber(state.pathViewer, props),
  });
};

export default connect(mapStateToProps)(Content);
